import { CategoryResult, CompetitionResult } from "../interfaces/ICompetitions";
import { createContext, ReactNode, useContext } from "react";
import { useCompetitionContext } from "./CompetitionContext";
import { useParams } from "react-router-dom";

interface CategoryContextType {
  category: CategoryResult | null;
  competition: CompetitionResult | null;
  loading: boolean;
  error: string | null;
}

const CategoryContext = createContext<CategoryContextType | undefined>(undefined);

export const useCategoryContext = (): CategoryContextType => {
  const context = useContext(CategoryContext);
  if (context === undefined) {
    throw new Error("useCategoryContext must be used within a CategoryContextProvider");
  }
  return context;
};

interface CategoryContextProviderProps {
  children: ReactNode;
}

export const CategoryContextProvider = ({ children }: CategoryContextProviderProps) => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const { competition, loading, error } = useCompetitionContext();

  const category = competition?.categories.find((cat) => cat.categoryId === categoryId) || null;

  return (
    <CategoryContext.Provider
      value={{
        category,
        competition,
        loading,
        error,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};
